module.exports = __webpack_public_path__ + "static/media/arrow-down-md-dark.15df3a77.svg";